import ProductBreifGuideSwiper from '@elem/compCommon/ProductConstructor/BriefGuide/Swiper';
import { formatCountdown } from '@elem/utils/countdown';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { actIdGetAccessFlow, actIdUpdateAccessFlow } from '@/service/crowdfunding';
import { ACTIVITY_MAP, CROWDFUNDING_END } from '@/constants/deltapro3';
import { formatFlow } from '@/constants/crowdfunding';

export default function Guide() {
    const { useLang, useEffect, useState, useRouter, useRef, gtm } = useGlobal();
    const { t } = useLang('dp3.crowdfunding.guide');
    const { locale, query } = useRouter();
    const [totalFlow, setTotalFlow] = useState(0);
    const activityId = ACTIVITY_MAP[locale];
    const timer: any = useRef(null);
    const end = CROWDFUNDING_END[locale];
    const [timerObj, setTimerObj] = useState(null);
    let nowTime = query?.timer ? new Date(query?.timer).getTime() : new Date().getTime();

    const swiperData = [
        // {
        //     img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718866171227/a1.jpg',
        //     imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718866372739/b1.jpg',
        // },
        {
            poster: 'https://websiteoss.ecoflow.com/upload/image/1720492857549/2.jpg',
            video: 'https://websiteoss.ecoflow.com/upload/video/1720496440617/-daa2-40f9-9065-b399d7fbabd1.mp4',
            // img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718866196089/a2.jpg',
            // imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718866385027/b2.jpg',
        },
        // {
        //     img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718866211325/a3.jpg',
        //     imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718866400185/b3.jpg',
        // },
        // {
        //     img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718866225002/a4.jpg',
        //     imgPad: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718866413155/b4.jpg',
        // },
    ];

    useEffect(() => {
        if (nowTime < end) {
            timer.current = setInterval(() => {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                nowTime += 1000;
                setTimerObj(formatCountdown(end - nowTime));
                if (nowTime.current > end) {
                    clearInterval(timer.current);
                    timer.current = null;
                }
            }, 1000);
        } else {
            clearInterval(timer.current);
            timer.current = null;
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const onVisibleChange = async () => {
                if (window.document.visibilityState === 'visible') {
                    // eslint-disable-next-line react-hooks/exhaustive-deps
                    nowTime = new Date().getTime();
                }
            };
            // 监听切屏事件
            window.document.addEventListener('visibilitychange', onVisibleChange);
            return window.document.removeEventListener('visibilitychange', onVisibleChange);
        }
    }, []);

    useEffect(() => {
        if (activityId) {
            (async () => {
                try {
                    const res = await actIdGetAccessFlow({ activityId });
                    if (res?.code === '0') {
                        setTotalFlow(Math.max(res?.data?.totalFlow, totalFlow));
                    } else {
                        console.error('get access flow failed: ', res?.message);
                    }

                    const resUpdate = await actIdUpdateAccessFlow({ activityId });
                    if (resUpdate?.code !== '0') {
                        console.error('update access flow failed: ', resUpdate?.message);
                    }
                } catch (e) {
                    console.error('access flow failed', e);
                }
            })();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activityId]);

    return (
        <div className={`dp3-crowdfunding-guide ${css['dp3-crowdfunding-guide']}`}>
            <ProductBreifGuideSwiper swiperArr={swiperData} langKey={'dp3.crowdfunding'} />
            <div className="product-info">
                {t('subtitle') && <p className="subtitle">{t('subtitle')}</p>}
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
                <div className="visitors">
                    <svg className="user" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <path
                            d="M14.3194 16.0424C17.7239 16.0424 20.4838 13.2387 20.4838 9.78023C20.4838 6.32175 17.7239 3.5181 14.3194 3.5181C10.9149 3.5181 8.15503 6.32175 8.15503 9.78023C8.15503 13.2387 10.9149 16.0424 14.3194 16.0424Z"
                            stroke="#03060B"
                            strokeWidth="2.2"
                        />
                        <path
                            d="M24.6046 26.5819C24.6046 20.9459 20.0963 16.377 14.5351 16.377C8.97394 16.377 4.4657 20.9459 4.4657 26.5819"
                            stroke="#03060B"
                            strokeWidth="2.2"
                        />
                    </svg>
                    <div className="visitors-info">
                        <p className="v-n">{totalFlow <= 0 ? '--' : formatFlow(totalFlow)}</p>
                        <p className="v-tip">{t('interest')}</p>
                    </div>
                </div>
                {Number(timerObj?.d) >= 8 && (
                    <div className="tip">
                        <p className="tip-title">{t('tip_title')}</p>
                        <p className="tip-desc">{t('tip_desc')}</p>
                    </div>
                )}
                {Number(timerObj?.d) < 8 && (
                    <div className="timer-box">
                        <svg className="clock" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                            <path
                                d="M14.5 26.6845C20.1211 26.6845 24.6778 22.129 24.6778 16.5094C24.6778 10.8899 20.1211 6.33437 14.5 6.33437C8.87901 6.33437 4.32227 10.8899 4.32227 16.5094C4.32227 22.129 8.87901 26.6845 14.5 26.6845Z"
                                stroke="#03060B"
                                strokeWidth="2.2"
                            />
                            <path d="M11.0919 2.09032H17.8548" stroke="#03060B" strokeWidth="2.2" />
                            <path d="M14.4731 11.1942V16.4693H18.8764" stroke="#03060B" strokeWidth="2.2" strokeLinejoin="round" />
                            <path d="M22.5077 5.58974L20.7725 8.4898" stroke="#03060B" strokeWidth="2" />
                            <path d="M20.781 4.72858L24.1116 6.6546" stroke="#03060B" strokeWidth="2" />
                            <path d="M14.4731 2.71263V5.58973" stroke="#03060B" strokeWidth="2.2" />
                        </svg>
                        <div className="timer-info">
                            <p className="timer-title">{t('timer_title')}</p>
                            <ul className="timer-inner">
                                {timerObj?.d && (
                                    <li className="timer-cell d">
                                        <span className="cell-n">{timerObj?.d}</span>
                                        <p className="cell-unit">{t('timer_d')}</p>
                                    </li>
                                )}
                                {timerObj?.h && (
                                    <li className="timer-cell h">
                                        <span className="cell-n">{timerObj?.h}</span>
                                        <p className="cell-unit">{t('timer_h')}</p>
                                    </li>
                                )}
                                {timerObj?.m && (
                                    <li className="timer-cell m">
                                        <span className="cell-n">{timerObj?.m}</span>
                                        <p className="cell-unit">{t('timer_m')}</p>
                                    </li>
                                )}
                                {timerObj?.s && (
                                    <li className="timer-cell s">
                                        <span className="cell-n">{timerObj?.s}</span>
                                        <p className="cell-unit">{t('timer_s')}</p>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
